var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details mt-1",on:{"click":function($event){return _vm.gotoSubAssets()}}},[_c('p',[_vm._v(_vm._s(_vm.$t("category.detail")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }